import React from 'react';

const ActivityFormMultiSelectorSelected = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onItemClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedItems,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  StyledItem,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  caption,
}) => {
  return (
    <>
      <h4>{caption}</h4>
      <StyledItem>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {selectedItems.map(item => (
          <span key={item}>
            {item}
            <button type='button' onClick={() => onItemClick(item)}>
              <i className='fas fa-times' />
            </button>
          </span>
        ))}
      </StyledItem>
    </>
  );
};

export default ActivityFormMultiSelectorSelected;
